/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/catering-ustrichniy-bar'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import CateringBar from '@routes/CateringBar/component';

export const Route = createFileRoute('/catering-ustrichniy-bar')({
  staticData: { layout: { landingFooter: true, withoutHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute component={CateringBar} path='/catering-ustrichniy-bar' />
  )
});
